import React,  { Component } from 'react';
import { drizzleConnect } from 'drizzle-react';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import config from '../config';

class EthereumLoader extends Component {
  constructor() {
    super();
    this.cookies = new Cookies();
    this.state = {
      loading: config.ALWAYS_SHOW_LOADING || !this.cookies.get('hasVisited'),
      isAnimating: false
    };
    this.loadingClass = this.loadingClass.bind(this);
    this.animationClass = this.animationClass.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.drizzleStatus.initialized && this.state.loading) {
      this.startLoadingAnimation();
    }
  }

  startLoadingAnimation() {
    this.cookies.set('hasVisited', true);
    setTimeout(() => {
      this.setState({ loading: false, isAnimating: true });
      setTimeout(() => {
        window.dispatchEvent(new Event('resize')); // Fix canvas for particles
        this.setState({ isAnimating: false })
      }, 3200);
    }, 100);
  }

  animationClass() {
    const isAnimatingOrLoading = this.state.isAnimating || this.state.loading;
    return isAnimatingOrLoading ? 'animating' : '';
  }

  loadingClass() {
    return this.state.loading ? 'loading' : 'loaded';
  }

  render() {
    if (this.props.drizzleStatus.initialized) {
      return (
        <div className={`ethereum-loader ${this.loadingClass()} ${this.animationClass()}`}>
          <div className="loading-container">
            <h1>Making it easier&nbsp;
              <b>Ether DNS</b>&nbsp;
              <i className="fab fa-ethereum"></i>
            </h1>
          </div>
          {this.props.children}
        </div>
      );
    } else {
      return (
        <div className="loading-screen">
          <div className="loading-animation">
            <i className="fab fa-ethereum"></i>
          </div>
        </div>
      );
    }
  }
}

EthereumLoader.contextTypes = {
  drizzle: PropTypes.object
}

const mapStateToProps = state => {
  return { drizzleStatus: state.drizzleStatus }
}
export default drizzleConnect(EthereumLoader, mapStateToProps)


// WEBPACK FOOTER //
// ./src/components/EthereumLoader.js